import { defineFcm } from '../shared/factory';

export const FCM_ADVOCATES_PSF_END_REDIRECT = defineFcm('advocates_psf_end_redirect')
	.asString()
	.withDefault('/')
	.toConfig();
